import React, { useEffect, useMemo, useState } from 'react'
import { ConnectedProps, connect } from 'react-redux'
import { compose } from 'recompose'

import { FEATURE_FLAGS } from 'constants/security'
import { WrappedComponentType } from 'constants/types'
import { Nursery } from 'services/nurseries/models'

import auth from 'utils/auth'

import { withAppService, withAppServiceProps } from 'services/app'
import { withNurseryContextService, withNurseryContextServiceProps } from 'services/nurseryContext'

import AppMarketplaceView from './AppMarketplaceView'
import { getMarketPlaceData } from './helpers'

const NURSERY_SETTINGS_GROUPS = {
  read: [
    'nurseryIntegration',
    'nurseryIntegrations.stripe',
  ],
}

const mapState = (state, { appSelectors, params }) => ({
  mobilePaymentsIsEnabled: auth.SELECTORS.getIsAuthorised(state, {
    flags: [FEATURE_FLAGS.MOBILE_PAYMENTS],
  }),
  nurseryOptions: appSelectors.getContextNurseryRouterConfig(state, params),
})

const connector = connect(mapState)

type PropsFromRedux = ConnectedProps<typeof connector>

type AppMarketplaceContainerFullProps = PropsFromRedux
  & withAppServiceProps
  & withNurseryContextServiceProps

const AppMarketplaceContainer: WrappedComponentType<AppMarketplaceContainerFullProps> = ({
  mobilePaymentsIsEnabled,
  nurseryContextActions,
  nurseryOptions,
}) => {
  const [isBePaidFetching, setIsBePaidFetching] = useState<boolean>(mobilePaymentsIsEnabled)
  const [nurseryData, setNurseryData] = useState<Nursery>()

  useEffect(() => {
    if (mobilePaymentsIsEnabled) {
      nurseryContextActions.getSettings({
        onSuccess: (response) => {
          setNurseryData(response?.data)
          setIsBePaidFetching(false)
        },
        onlyData: true,
        params: [nurseryOptions.id, {
          groups: NURSERY_SETTINGS_GROUPS,
        }],
      })
    }
  }, [])

  const marketPlaceData = useMemo(() => (
    getMarketPlaceData({ isBePaidFetching, mobilePaymentsIsEnabled, nurseryData })
  ), [
    isBePaidFetching,
    nurseryData,
  ])

  return (
    <AppMarketplaceView marketPlaceData={marketPlaceData} />
  )
}

AppMarketplaceContainer.authParams = {
  flags: [FEATURE_FLAGS.APP_MARKETPLACE],
}

const enhance = compose(
  withAppService,
  withNurseryContextService,
  connector,
)

export default enhance(AppMarketplaceContainer)
